<template>
  <a-drawer
    :open="open"
    :width="480"
    class="custom-class"
    root-class-name="root-class-name"
    placement="right"
    @close="close('inventory')"
  >
    <section>
      <Text :type="'subHeader'" :text="'Update Inventory'" />
      <Text :type="'textFadedMedium'" :text="'Edit product and volume'" />
      <div v-if="activeProducts.length" class="mt-2">
        <div v-bind:key="index" v-for="(product, index) in activeProducts">
          <div
            class="flex items-center justify-between px-3 py-2 mb-3 border rounded-lg border-grey300"
          >
            <div>
              <div class="flex items-center">
                <span>
                  <img src="@/assets/svg/productPms.svg" />
                </span>
                <span class="text-sm text-grey500">
                  {{ product.productName }}
                </span>
              </div>
              <div>
                <p class="mt-2 text-base text-grey500">
                  {{ product.recieved_volume }}
                </p>
              </div>
            </div>
            <div @click="editProduct(product)" class="cursor-pointer">
              <img src="@/assets/svg/edit.svg" />
            </div>
          </div>
        </div>
      </div>
      <form @submit.prevent="handleSubmit" action="" class="mt-4">
        <div class="mt-3">
          <LabelText :forVal="'productSelect'" :labelText="'Select product'" />
          <select
            class="w-full px-4 py-2 text-base bg-transparent border rounded-lg border-grey300 font-quietSans placeholder-grey500 outline-foundationGrey500 focus:border-foundationGrey500"
            name="name"
            v-model="productName"
            :value="productName"
          >
            <option value="" selected disabled>Select a product</option>
            <option
              v-bind:key="product.id"
              :value="product.depotProductName"
              v-for="product in products"
            >
              {{ product.depotProductName }}
            </option>
            <!-- <option value="PMS">PMS</option>
            <option value="LPFO">LPFO</option>
            <option value="AGO">AGO</option> -->
          </select>
        </div>

        <div class="mt-3">
          <LabelText :forVal="'r_volume'" :labelText="'Received volume'" />

          <input
            class="w-full px-4 py-2 text-sm border rounded-md border-foundationGrey500 font-quietSans placeholder-foundationGrey500 outline-foundationGrey500 focus:border-foundationGrey500"
            v-model="recieved_volume"
            :placeholder="'Recieved volume'"
            :name="'received_volume'"
            :type="'text'"
            :value="recieved_volume"
            min="0"
          />
          <!-- <drawer-input
            type="text"
            name="received_volume"
            :placeholder="'Received volume'"
            v-model="recieved_volume"
          /> -->
        </div>

        <div class="mt-3">
          <LabelText :forVal="'shipment_info'" :labelText="'Vessel ID'" />
          <input
            class="w-full px-4 py-2 text-sm border rounded-md border-foundationGrey500 font-quietSans placeholder-foundationGrey500 outline-foundationGrey500 focus:border-foundationGrey500"
            v-model="shipment_info"
            :placeholder="'Vessel ID'"
            :name="'shipment_info'"
            :type="'text'"
            :value="shipment_info"
          />
        </div>

        <div class="mt-3">
          <LabelText :forVal="'date'" :labelText="'Date received'" />

          <VueDatePicker
            color="#00903a"
            input-size="sm"
            v-model="date"
            :min-date="todayDate"
            no-label
            format="YYYY-MM-DDTHH:mm:ss"
          />
        </div>
        <div
          v-if="activeProducts.length > 1"
          class="flex items-center my-2 cursor-pointer"
          @click="addProduct"
        >
          <span><img src="@/assets/svg/addGreen.svg" /></span>
          <p class="ml-2 text-sm text-primaryGreen">Add more product</p>
        </div>
        <div class="mt-8">
          <FormSubmitInput :val="'Update inventory'" :loading="loading" />
        </div>
      </form>
    </section>
  </a-drawer>
</template>

<script>
//Library
import moment from "moment";
import { useToast } from "vue-toastification";

//services
import depotService from "@/services/depot-service";

import DrawerInput from "../../../UI/Inputs/DrawerInput.vue";
import FormSubmitInput from "../../../UI/Inputs/FormSubmitInput.vue";
import LabelText from "../../../UI/Text/LabelText.vue";
import Text from "../../../UI/Text/Text.vue";
export default {
  components: { Text, LabelText, DrawerInput, FormSubmitInput },
  props: ["open", "close", "products", "getDepotDetails"],
  data() {
    return {
      toast: useToast(),
      activeProducts: [],
      productName: "",
      recieved_volume: "",
      shifment_info: "",
      date: "",
      loading: false,
      todayDate: moment().format("YYYY-MM-DD"),
    };
  },
  mounted() {
    console.log(this.products);
  },
  methods: {
    async handleSubmit() {
      let urlVal = new URLSearchParams(window.location.search);
      urlVal = urlVal.get("id");
      this.loading = true;
      if (!this.handleVerification()) {
        this.toast.error(
          "All fields for the current product selection are required",
          {
            timeout: 5000,
          }
        );
        this.loading = false;
        return;
      }
      this.addProduct();
      const mappedProd = this.activeProducts.map((item) => {
        return {
          vesselId: item.shipment_info,
          dateReceived: item.date,
          quantity: this.stripNonNumber(item.recieved_volume),
          productId: item.productId,
        };
      });

      // make the api call;
      try {
        const depotUpdate = await depotService.updateInventory({
          depotId: urlVal,
          inventory: mappedProd,
        });
        this.toast.success("Inventory updated successfully", { timeout: 2000 });
        this.getDepotDetails();
        this.close("inventory");
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }

      // The logic to remove product from the list that can be selected
    },

    stripNonNumber(val) {
      return val
        .split("")
        .map((item) => {
          return !isNaN(item) || item === "." ? item : "";
        })
        .join("")
        .replaceAll(" ", "");
    },

    handleVerification() {
      if (
        !this.productName ||
        !this.recieved_volume ||
        !this.shipment_info ||
        !this.date ||
        this.recieved_volume < 0
      ) {
        return false;
      }
      return true;
    },
    editProduct(product) {
      this.productName = product.productName;
      this.recieved_volume = product.recieved_volume;
      this.shipment_info = product.shipment_info;
      this.date = product.date;
    },

    resetFields() {
      (this.productName = ""),
        (this.recieved_volume = ""),
        (this.shipment_info = ""),
        (this.date = "");
    },
    resolveProductId(productName) {
      return this.products.find((item) => item.depotProductName === productName)
        .depotProductId;
    },
    addProduct() {
      // Validate before pushing

      if (!this.handleVerification()) {
        this.toast.error(
          "All fields for the current product selection are required",
          {
            timeout: 5000,
          }
        );
        return;
      }

      const findVal = this.activeProducts.findIndex(
        (item) => item.productName == this.productName
      );
      // Update if you find a new one
      if (findVal !== -1) {
        this.activeProducts[findVal] = {
          productName: this.productName,
          recieved_volume: this.recieved_volume,
          shipment_info: this.shipment_info,
          date: this.date,
          productId: this.resolveProductId(this.productName),
        };
      } else {
        // create a new one
        this.activeProducts.push({
          productName: this.productName,
          recieved_volume: this.recieved_volume,
          shipment_info: this.shipment_info,
          date: this.date,
          productId: this.resolveProductId(this.productName),
        });
      }

      this.resetFields();
    },
    async getProductSale() {
      // try {
      //   let urlVal = new URLSearchParams(window.location.search);
      //   console.log(urlVal);
      //   urlVal = urlVal.get("id");
      //   const depotSalesDetails = await depotService.getDepotProductSale(
      //     urlVal
      //   );
      // } catch (e) {
      //   this.toast.error("Some error occured", { timeout: 2000 });
      // }
    },
  },
};
</script>

<style></style>
